var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flat",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m44.095 26.401 11 19.053 7.905-4.564v-25.403z",
    fill: "#6a7f91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.095 26.401 11 19.053 7.905-4.564v-25.403z",
    fill: "#788d9e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.096 28.133 9.999 17.321 7.905-4.564v-23.094z",
    fill: "#6a7f91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m35.188 58.1 8.283-4.782a15 15 0 0 0 6.294-7.1l4.33-2.5-9-15.589-4.33 2.5-3.556-.541a8 8 0 0 0 -5.2.98l-7.962 4.6",
    fill: "#f5c0a6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m32.467 54.679 3.533 4.213a2.5 2.5 0 0 1 -.308 3.523 2.5 2.5 0 0 1 -3.521-.307l-3.359-4.008 1.032 1.2-9.315-5.98a15 15 0 0 1 -6.294-7.1l-4.33-2.5 9-15.589 4.33 2.5 3.556-.541a8 8 0 0 1 5.2.98l7.962 4.6",
    fill: "#fcd4c5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.53 37.377 11.248 13.406a2.5 2.5 0 0 1 -.308 3.522 2.5 2.5 0 0 1 -3.522-.305l-11.248-13.409",
    fill: "#fcd4c5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m33.7 40.591 12.312 14.674a2.5 2.5 0 0 1 -.308 3.522 2.5 2.5 0 0 1 -3.522-.309l-12.313-14.673",
    fill: "#fcd4c5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m29.869 43.805 11.249 13.406a2.5 2.5 0 0 1 -.308 3.522 2.5 2.5 0 0 1 -3.522-.308l-11.249-13.406",
    fill: "#fcd4c5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m38.978 49.216a.75.75 0 0 1 .093-1.057.75.75 0 0 1 1.056.092l5.885 7.014a2.5 2.5 0 0 1 -.308 3.522 2.473 2.473 0 0 1 -.657.384 2.49 2.49 0 0 0 -.184-2.942z",
    fill: "#f9c9b2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5c0a6"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 2.5,
    transform: "matrix(.643 -.766 .766 .643 -32.898 32.14)",
    width: 7.728,
    x: 14.15,
    y: 48.845
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 2.5,
    transform: "matrix(.643 -.766 .766 .643 -34.667 36.041)",
    width: 9.383,
    x: 16.62,
    y: 52.693
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 2.5,
    transform: "matrix(.643 -.766 .766 .643 -35.086 40.304)",
    width: 7.728,
    x: 21.81,
    y: 55.273
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.785 57.721h.727a2.5 2.5 0 0 1 2.5 2.5 2.5 2.5 0 0 1 -2.5 2.5h-.729a2.5 2.5 0 0 1 -2.5-2.5 2.5 2.5 0 0 1 2.502-2.5z",
    transform: "matrix(.643 -.766 .766 .643 -35.362 44.607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.765 30.633-3.556-.541a8 8 0 0 0 -5.2.98l-8.36 4.828a2.5 2.5 0 0 0 -.915 3.415 2.5 2.5 0 0 0 3.415.915l6.495-3.75a8 8 0 0 0 10.929 2.929"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m49.193 23.427h6v22h-6z",
    fill: "#f5fdff",
    transform: "matrix(.866 -.5 .5 .866 -10.221 30.709)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m19.905 26.401-11 19.053-7.905-4.564v-25.403z",
    fill: "#788d9e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m1 40.89 7.905 4.564 9.999-17.321-17.904-10.337z",
    fill: "#6a7f91"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m.806 31.427h22v6h-22z",
    fill: "#f5fdff",
    transform: "matrix(.5 -.866 .866 .5 -23.912 27.438)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m36.3 51.465a.749.749 0 0 0 -1.056-.092.75.75 0 0 0 -.093 1.057l4.821 5.745a2.492 2.492 0 0 1 .185 2.942 2.467 2.467 0 0 0 .656-.384 2.5 2.5 0 0 0 .308-3.523z",
    fill: "#f9c9b2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m31.318 55.644a.75.75 0 0 1 .092-1.057.751.751 0 0 1 1.057.092l3.533 4.214a2.5 2.5 0 0 1 -.308 3.522 2.473 2.473 0 0 1 -.657.384 2.49 2.49 0 0 0 -.184-2.942z",
    fill: "#f9c9b2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m19.656 50.943-1.756 2.089a2.491 2.491 0 0 1 -2.865.693 2.459 2.459 0 0 0 .493.58 2.5 2.5 0 0 0 3.524-.305l1.753-2.09a2.468 2.468 0 0 0 -.965-3.91 2.493 2.493 0 0 1 -.184 2.943z",
    fill: "#ebb69d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m23.486 54.157-2.817 3.357a2.493 2.493 0 0 1 -2.866.693 2.467 2.467 0 0 0 4.015.271l2.817-3.357a2.469 2.469 0 0 0 -.964-3.907 2.493 2.493 0 0 1 -.185 2.943z",
    fill: "#ebb69d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m27.316 57.371-1.753 2.089a2.492 2.492 0 0 1 -2.866.693 2.467 2.467 0 0 0 4.015.272l1.753-2.09a2.469 2.469 0 0 0 -.964-3.907 2.493 2.493 0 0 1 -.185 2.943z",
    fill: "#ebb69d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m31.149 60.584-.468.558a2.492 2.492 0 0 1 -2.867.692 2.47 2.47 0 0 0 4.016.272l.468-.557a2.5 2.5 0 0 0 -.308-3.522 2.447 2.447 0 0 0 -.655-.384 2.492 2.492 0 0 1 -.186 2.941z",
    fill: "#ebb69d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m1.306 32.293h20v6h-20z",
    fill: "#e6f5fa",
    transform: "matrix(.5 -.866 .866 .5 -24.912 27.438)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m49.193 23.427h6v22h-6z",
    fill: "#f5fdff",
    transform: "matrix(.866 -.5 .5 .866 -10.221 30.709)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m49.694 25.293h6v20h-6z",
    fill: "#e6f5fa",
    transform: "matrix(.866 -.5 .5 .866 -10.587 31.075)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 13,
    fill: "#b6f085",
    r: 12
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m34 3a11.988 11.988 0 0 0 -9.419 19.419 11.988 11.988 0 0 0 16.838-16.838 11.93 11.93 0 0 0 -7.419-2.581z",
    fill: "#a0e576"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m29.525 15.121-2.475-2.475a1.5 1.5 0 0 0 -2.121 0 1.5 1.5 0 0 0 0 2.122l3.535 3.532a1.5 1.5 0 0 0 2.122 0l8.485-8.485a1.5 1.5 0 0 0 0-2.121 1.5 1.5 0 0 0 -2.121 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/partnership.3d6f4f47901cf57d35922c4e0c38c460.svg";
export { ForwardRef as ReactComponent };